import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingBag, User, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import logo from "@/assets/logo.png";

const NAV = [
  { to: "/boutique", label: "La Boutique" },
  { to: "/histoire", label: "L'Histoire" },
  { to: "/gazette", label: "La Gazette" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { count, setIsOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header data-testid="site-header" className="sticky top-0 z-40 border-b border-amber-900/10 bg-cream/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-8">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center">
            <img src={logo} alt="Pétales de Miel" className="h-11 w-11 object-contain" />
          </span>
          <span className="font-serif text-xl font-semibold tracking-tight text-bark sm:text-2xl">
            Pétales de <span className="italic text-amber-deep">Miel</span>
          </span>
        </Link>

        <nav data-testid="desktop-nav" className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-amber-deep" : "text-bark-soft hover:text-amber-deep"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/compte"
            data-testid="account-link"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-amber-800/20 bg-white text-bark transition-all duration-200 hover:border-amber-deep hover:text-amber-deep"
            aria-label="Mon compte"
          >
            <User size={19} />
          </Link>
          <button
            data-testid="cart-open-button"
            onClick={() => setIsOpen(true)}
            className="relative flex h-11 w-11 items-center justify-center rounded-full border border-amber-800/20 bg-white text-bark transition-all duration-200 hover:border-amber-deep hover:text-amber-deep"
            aria-label="Ouvrir le panier"
          >
            <ShoppingBag size={19} />
            {count > 0 && (
              <span data-testid="cart-count-badge" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-amber-deep px-1 text-[11px] font-bold text-white">
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setMobileOpen((v) => !v)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-amber-800/20 bg-white text-bark md:hidden"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={19} /> : <Menu size={19} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav data-testid="mobile-nav" className="border-t border-amber-900/10 bg-cream px-6 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`mobile-nav-${item.to.slice(1)}`}
                onClick={() => setMobileOpen(false)}
                className="text-base font-medium text-bark-soft"
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}
